import { BookOpen, ChevronRight, FileText, Settings, User, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

import { categories } from '../../content/registry';

import { CategorySection } from './CategorySection';

const roleLinks = [
  {
    path: '/manager',
    label: 'マネージャー向け',
    icon: Users,
    description: '1on1・部下管理・レポート',
  },
  {
    path: '/member',
    label: 'メンバー向け',
    icon: User,
    description: 'プロフィール・1on1参加・レポート',
  },
  {
    path: '/admin',
    label: 'テナント管理者向け',
    icon: Settings,
    description: 'ユーザー管理・部署管理・設定',
  },
] as const;

export function TopPage() {
  return (
    <div>
      {/* Page title */}
      <div className='mb-10'>
        <div className='mb-2 flex items-center gap-3'>
          <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-accent'>
            <BookOpen size={22} className='text-primary' />
          </div>
          <h1 className='text-2xl font-bold text-text'>TONOME Core ユーザーガイド</h1>
        </div>
        <p className='ml-[52px] text-sm text-text-secondary'>
          操作方法・設定・トラブルシューティング
        </p>
      </div>

      {/* Role-based navigation */}
      <section className='mb-10'>
        <h2 className='mb-4 text-lg font-bold text-text'>あなたの役割に合ったガイドを見る</h2>
        <div className='grid grid-cols-3 gap-3'>
          {roleLinks.map(({ path, label, icon: Icon, description }) => (
            <Link
              key={path}
              to={path}
              className='group flex items-center gap-4 rounded-lg border border-border bg-white p-4 transition-colors hover:border-primary'
            >
              <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent transition-colors group-hover:bg-primary/10'>
                <Icon size={20} className='text-primary' />
              </div>
              <div className='min-w-0 flex-1'>
                <div className='flex items-center gap-1 text-sm font-bold text-text'>
                  {label}
                  <ChevronRight
                    size={14}
                    className='shrink-0 text-[#C0C0C0] transition-colors group-hover:text-primary'
                  />
                </div>
                <p className='text-xs text-text-secondary'>{description}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Category sections */}
      {categories.map((category) => (
        <CategorySection key={category.id} category={category} />
      ))}

      {/* Release notes link */}
      <div className='mt-10 border-t border-border pt-8'>
        <Link
          to='/release-notes'
          className='inline-flex items-center gap-2 text-sm text-text-secondary transition-colors hover:text-primary'
        >
          <FileText size={16} />
          リリースノート
        </Link>
      </div>
    </div>
  );
}
